import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Box from 'app/components/v2/components/Box';
import Tooltip from 'app/components/v2/components/Tooltip';
import { images } from 'app/constants/images';

// Local Typings
interface Props {
  isDisabled?: boolean;
  isFactored?: boolean;
  withMarginRight?: boolean;
}

// Local Variable
const getImageSource = (isDisabled: boolean, isFactored: boolean): string => {
  if (isFactored) {
    return images.selectCarrierFactoredBadgeSmall.full;
  }

  return isDisabled
    ? images.selectCarrierBadgeSmallDisabled.full
    : images.selectCarrierBadgeSmall.full;
};

// Component Definition
const SmallSelectCarrierBadge: FC<Props> = ({
  isDisabled = false,
  isFactored = false,
  withMarginRight,
}) => {
  const { t } = useTranslation('components');
  const imageRef = useRef<HTMLImageElement>(null);

  return (
    <Tooltip
      childRef={imageRef}
      tooltipLabel={t('smallSelectCarrierBadge.tooltip', 'Triumph Payments Select Carrier')}
      tooltipPlacement="right"
    >
      <Box marginRight={withMarginRight ? 8 : 0}>
        <img
          alt={t('smallSelectCarrierBadge.imgAlt', 'Triumph Payments Select Carrier Logo')}
          ref={imageRef}
          src={getImageSource(isDisabled,
            isFactored)}
        />
      </Box>
    </Tooltip>

  );
};

export default SmallSelectCarrierBadge;
